/* eslint-disable */
/* eslint-disable indent */
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styled, { ThemeProvider } from 'styled-components'
import { Grid } from 'react-bootstrap'
import { connect } from 'react-redux'
import { browserHistory } from 'react-router'
import { some } from 'lodash'
import Cookies from 'js-cookie'
import {
  HeaderContainer,
  DeviceSelectorContainer,
  ErrorBoundary,
  BotContainer,
  FooterContainer
} from '..'
import {
  InlineLoader,
  SearchModal,
  GlobalStyleInject,
  ScriptInject,
  Slider
} from '../../components'
import {
  selectStyles,
  selectCustomer,
  selectLanguage,
  selectCurrentPhoneId,
  selectCurrentPhone
} from './selectors'
import { selectQuestions } from '../FAQs/selectors'
import { selectVideos } from '../Videos/selectors'
import { selectGuides } from '../Guides/selectors'
import { selectTutorials } from '../Tutorials/selectors'
import { selectCurrentPhoneStarterContentId } from '../GettingStarted/selectors'
import { selectDevices, selectAllDevices } from '../DeviceSelector/selectors'
import { fetchCustomer, swapLanguage } from './actions'
import { fetchLandingContent, fetchFAQ } from '../FAQs/actions'
import { fetchContactOptions } from '../ContactUsModal/actions'
import { fetchDevices } from '../DeviceSelector/actions'
import { fetchSpecs } from '../Specs/actions'
import { fetchStartContent } from '../GettingStarted/actions'
import { fetchVideos } from '../Videos/actions'

import { fetchGuides } from '../Guides/actions'
import { fetchTutorialList } from '../Tutorials/actions'
import { createEvent } from '../UserEvents/actions'
import { adddMessageListener, faqsFlat } from '../../helpers/utils'
import { OptionsHOC } from '../../hocs'
import AppContextProvider from './Context'
import { fetchAcademyApi } from '../../services/academy-api'
import SEO from '../../components/SEO'
import DeviceLoader from '../DeviceLoader'
import EmergencyBanner from '../../components/EmergencyBanner'
import InitializeGA from '../InitializeGA'

const AppStyles = styled.div`
  background-color: var(--clr-bg);
  min-height: calc(100vh - var(--footer-height));
`

const GridWrapper = styled.div`
  .content-body {
    @media (max-width: 1366px) {
      margin-right: ${props => props.botOpen && '242px'};
    }
    @media (min-width: 1367px) and (max-width: 1436px) {
      margin-right: ${props => props.botOpen && '225px'};
    }

    @media (min-width: 1437px) {
      margin-right: ${props => props.botOpen && '156px'};
    }
  }

  #more-help {
    @media (max-width: 1366px) {
      margin-left: ${props => props.botOpen && '242px'};
    }

    @media (min-width: 1367px) and (max-width: 1436px) {
      margin-left: ${props => props.botOpen && '225px'};
    }

    @media (max-width: 1437px) {
      margin-left: ${props => props.botOpen && '242px'};
    }
  }
`

const ContentGrid = styled(Grid)`
  @media (max-width: 767px) {
    padding: 0;
  }
`

class AppContainer extends Component {
  static contextTypes = { router: PropTypes.object.isRequired }

  constructor(props) {
    super(props)
    this.state = {
      showDeviceModal: this.props.routes[1].name === 'start',
      showSearchModal: false,
      fetchingDeviceId: false,
      searchQuery: '',
      botOpen: false,
      showHeader: true
    }
    this.setSelectedDevice = this.setSelectedDevice.bind(this)
    this.toggleDeviceModal = this.toggleDeviceModal.bind(this)
    this.toggleSearchModal = this.toggleSearchModal.bind(this)
  }

  getChildContext() {
    return { language: this.props.language }
  }

  fetchData(currentDeviceId, specsRequest = false) {
    if (!currentDeviceId) {
      return
    }
    const {
      fetchVideos,
      fetchFAQ,
      fetchGuides,
      fetchTutorialList,
      fetchSpecs
    } = this.props

    if (specsRequest) {
      fetchSpecs(currentDeviceId)
      return
    }

    fetchFAQ(currentDeviceId)
    fetchVideos(currentDeviceId)
    fetchTutorialList(currentDeviceId)
    fetchGuides(currentDeviceId)
  }

  chooseTheme() {
    const { getOption } = this.props
    if (
      window.matchMedia &&
      window.matchMedia('(prefers-color-scheme: dark)').matches &&
      getOption('theme.dark.enabled')
    ) {
      document.body.classList.add('dark')
    }
  }

  componentDidUpdate(prevProps) {
    const {
      getOption,
      customer,
      fetchDevices,
      fetchLandingContent,
      fetchContactOptions
    } = this.props

    this.chooseTheme()
    if (customer && customer !== prevProps.customer) {
      fetchDevices(customer)
      fetchContactOptions(customer)

      const landingId = getOption('landing.deviceId')
      landingId && fetchLandingContent(landingId)
    }

    if (
      this.props.customer &&
      this.props.currentPhoneId &&
      this.props.currentPhoneId !== this.props.currentGettingStartedPhoneId
    ) {
      this.props.fetchStartContent(this.props.currentPhoneId)
    }
  }

  deviceNotFound(prevDevices, newDevices, currPhoneId) {
    return (
      prevDevices !== newDevices &&
      newDevices.length > 0 &&
      currPhoneId && currPhoneId !== 'null' &&
      !this.props.location.pathname.includes('/expresshelp') &&
      !some(newDevices, ['id', parseInt(currPhoneId)])
    )
  }

  componentWillReceiveProps(nextProps) {
      const {
        currentPhoneId,
        currentPhone,
        customer,
        query,
        devices,
        location
      } = this.props

      if (
        !this.state.showHeader &&
        location.pathname !== nextProps.location.pathname
      ) {
        window.parent.postMessage(
          { type: 'locationChange', value: nextProps.location },
          '*'
        )
      }

    if (
      (currentPhoneId !== nextProps.currentPhoneId && nextProps.customer) ||
      (customer !== nextProps.customer && nextProps.currentPhoneId)
    ) {
      this.fetchData(nextProps.currentPhoneId)
    }

    if (
      ((currentPhone !== nextProps.currentPhone && nextProps.customer) ||
        (customer !== nextProps.customer && nextProps.currentPhone)) &&
      nextProps.currentPhone !== undefined
    ) {
      this.fetchData(nextProps.currentPhone.customerID, true)
    }

    const currPhoneId = localStorage.getItem('currentPhoneId')
    if (
      this.deviceNotFound(
        devices,
        nextProps.devices,
        currPhoneId)
    ) {
      delete query.device
      this.context.router.replace({
        pathname: '/',
        query
      })
      this.forceUpdate()
    }
  }

  setDeviceAndLanguage(deviceId, language, customerId) {
    if (!deviceId && customerId) {
      // deviceId lookup failed, send to 404
      this.context.router.replace({
        pathname: '/notfound',
        state: { deviceLookupFailure: true }
      })
      this.forceUpdate()
      return
    }

    if (['es', 'es-ud'].includes(language) || customerId) {
      this.props.swapLanguage(language)
      const { query } = this.props
      if (customerId) {
        delete query.custId
        query.device = deviceId
        query.lang = language
      }
      this.context.router.replace({
        pathname: this.props.location.pathname,
        query
      })
      this.forceUpdate()
    }
  }

  componentWillMount() {
    if (this.props.location.query.showHeader === 'false') {
      this.setState({ showHeader: false })
    }
    const { fetchCustomer } = this.props
    let customerId
    let language
    const custOverride = this.props.location.query['customer-override']
      ? this.props.location.query['customer-override']
      : ''

    fetchCustomer(custOverride)

    if (this.props.location.query.custId) {
      customerId = this.props.location.query.custId
    }

    if (this.props.location.query.lang) {
      language = this.props.location.query.lang
    }

    if (customerId) {
      this.setState({ fetchingDeviceId: true })
      fetchAcademyApi(`/deviceid/${customerId}`).then(res => {
        this.setDeviceAndLanguage(
          parseInt(res.deviceid, 10),
          res.language || language,
          customerId
        )
        // Do a reload when device is fetched to load correct language content
        const url = window.location.href
        window.location.href = url
      })
    } else {
      this.setDeviceAndLanguage(undefined, language, customerId)
    }
  }

  componentDidMount() {
    const { location } = this.props
    // Open external links in new tab, open internal links without refresh
    document.addEventListener('click', function (event) {
      if (event.target.hasAttribute('href')) {

        event.preventDefault()
        const regex = new RegExp(`/${window.location.host}/`)
        const url = event.target.getAttribute('href')

        if (event.target.getAttribute('href') === '#') return

        if (!regex.test(event.target.href)) {
          window.open(url, '_blank')
        } else {
          browserHistory.push(url)
        }
      }
    })

    if (
      location.query.crd === 'webscr:webscr' ||
      location.query.crd === 'webcsr:webcsr'
    ) {
      Cookies.set('showHiddenTutorials', '1', { expires: 30 })
    }

    adddMessageListener('dbNav', data => {
      const { currentPhoneId } = this.props
      const isLoadBehindDifferentDeviceFaq =
        data.value.includes('faqs') &&
        currentPhoneId &&
        !data.value.includes(currentPhoneId)
      if (isLoadBehindDifferentDeviceFaq) {
        const faqs = faqsFlat(this.props.questions)
        const faq = faqs.find(faq => faq.name === data.title)
        if (faq && faq.pk) {
          return browserHistory.push(`/faqs/${faq.pk}?device=${faq.phoneFk}`)
        }
      }
      browserHistory.push(data.value)
    })

    adddMessageListener('botOpen', data => {
      if (data) {
        this.setState({ botOpen: data.value })
      }
    })
  }

  toggleDeviceModal() {
    this.setState({ showDeviceModal: !this.state.showDeviceModal })
  }

  toggleSearchModal(searchQuery) {
    this.setState({
      showSearchModal: !this.state.showSearchModal,
      searchQuery
    })
  }

  setSelectedDevice(deviceId, deviceName, filter, slug) {
    this.props.createUserEvent({
      category: 'deviceselector',
      data: {
        action: 'setDevice',
        device: { id: deviceId, name: deviceName },
        filter
      }
    })
    const { query } = this.props
    query.device = slug
    this.context.router.replace({
      pathname: '/devicehome',
      query
    })
    this.forceUpdate()
    this.setState({ showDeviceModal: false })
  }

  render() {
    const {
      customer,
      query,
      devices,
      createUserEvent,
      language,
      location,
      getOption
    } = this.props
    const { showHeader } = this.state
    const { fetchingDeviceId, searchQuery, botOpen } = this.state

    return (
      <ErrorBoundary createUserEvent={createUserEvent}>
        <Choose>
          <When condition={customer && !fetchingDeviceId}>
            <SEO language={language.substr(0, 2)} title="Support" />
            <AppContextProvider
              customer={customer}
              language={language}
              botOpen={botOpen}
              getOption={getOption}
            >
              <ThemeProvider theme={{ getOption }}>
                <React.Fragment>
                  <DeviceLoader location={location}>
                    <AppStyles className="db-font-override">
                      <InitializeGA />
                      <ScriptInject />
                      <GlobalStyleInject />
                      <EmergencyBanner
                        language={language}
                        createUserEvent={createUserEvent}
                      />
                      <div
                        style={{
                          overflow: 'auto',
                          paddingBottom: '100px'
                        }}
                      >
                        <If key={1} condition={this.state.showSearchModal}>
                          <SearchModal
                            onHide={this.toggleSearchModal}
                            initialQuery={searchQuery}
                          />
                        </If>
                        <DeviceSelectorContainer
                          show={this.state.showDeviceModal}
                          onHide={this.toggleDeviceModal}
                          setDevice={this.setSelectedDevice}
                        />
                        <HeaderContainer
                          location={location}
                          devices={devices}
                          toggleDeviceModal={this.toggleDeviceModal}
                          toggleSearchModal={this.toggleSearchModal}
                          showHeader={showHeader}
                        />
                        {window.location.pathname === '/' && (
                          <Slider theme={{ getOption }} />
                        )}
                        <GridWrapper botOpen={botOpen}>
                          <ContentGrid
                            toplinks={
                              getOption('header.linkBack.text') ||
                              getOption('header.linkLang.text')
                            }
                          >
                            {React.cloneElement(this.props.children, {
                              toggleSearchModal: this.toggleSearchModal,
                              toggleDeviceModal: this.toggleDeviceModal,
                              modalOpen:
                                this.state.showSearchModal ||
                                this.state.showDeviceModal
                            })}
                          </ContentGrid>
                        </GridWrapper>
                      </div>
                    </AppStyles>
                    {showHeader && (
                      <FooterContainer
                        query={query}
                        createUserEvent={createUserEvent}
                      />
                    )}
                  </DeviceLoader>
                  {showHeader && <BotContainer />}
                </React.Fragment>
              </ThemeProvider>
            </AppContextProvider>
          </When>
          <Otherwise>
            <InlineLoader />
          </Otherwise>
        </Choose>
      </ErrorBoundary>
    )
  }
}

AppContainer.childContextTypes = { language: PropTypes.string }

const mapStateToProps = (state, ownProps) => ({
  location: ownProps.location,
  styles: selectStyles(state),
  customer: selectCustomer(state),
  query: state.routing.locationBeforeTransitions.query,
  language: selectLanguage(state),
  devices: selectDevices(state),
  allDevices: selectAllDevices(state),
  currentPhone: selectCurrentPhone(state),
  currentPhoneId: selectCurrentPhoneId(state),
  questions: selectQuestions(state),
  videos: selectVideos(state),
  guides: selectGuides(state),
  tutorials: selectTutorials(state),
  currentGettingStartedPhoneId: selectCurrentPhoneStarterContentId(state)
})

const mapDispatchToProps = dispatch => ({
  fetchCustomer: custOverride => dispatch(fetchCustomer.request(custOverride)),
  fetchLandingContent: landingDeviceId =>
    dispatch(fetchLandingContent.request(landingDeviceId)),
  fetchDevices: customer => dispatch(fetchDevices.request(customer)),
  fetchContactOptions: customer =>
    dispatch(fetchContactOptions.request(customer)),
  fetchVideos: currentPhoneId => dispatch(fetchVideos.request(currentPhoneId)),
  fetchFAQ: currentPhoneId => dispatch(fetchFAQ.request(currentPhoneId)),
  fetchGuides: currentPhoneId => dispatch(fetchGuides.request(currentPhoneId)),
  fetchTutorialList: currentPhoneId =>
    dispatch(fetchTutorialList.request(currentPhoneId)),
  fetchSpecs: currentPhoneId => dispatch(fetchSpecs.request(currentPhoneId)),
  swapLanguage: language => dispatch(swapLanguage(language)),
  createUserEvent: event => dispatch(createEvent(event)),
  fetchStartContent: currentPhoneId =>
    dispatch(fetchStartContent.request(currentPhoneId))
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(OptionsHOC(AppContainer))



// WEBPACK FOOTER //
// ./src/containers/App/AppV2.js